<template>
  <v-container
    id="hero"
    class="px-0"
    tag="section"
    :class="$vuetify.breakpoint.smAndDown && 'pt-0'"
  >
    <v-responsive
      class="overflow-visible"
      min-height="70vh"
    >
      <v-row
        align="center"
        align-content="center"
        class="fill-height mx-0"
        justify="space-around"
      >
        <v-slide-x-transition
          v-if="$vuetify.breakpoint.mdAndUp"
          appear
        >
          <v-col
            cols="12"
            md="6"
            xl="5"
          >
            <!-- <base-img-card :src="require('@/assets/features/1.jpg')" /> -->
            <v-img eager class="card-float" :style="$margin('left', '-140px')" :src="require('@/assets/art/insurance-card.svg')"></v-img>
          </v-col>
        </v-slide-x-transition>

        <v-slide-x-reverse-transition appear>
          <v-col cols="12" md="6" xl="5" :style="$margin('right', '-100px')">
            <h1
              class="font-weight-bold mb-2"
              :class="[$vuetify.breakpoint.smAndDown ? 'display-3 white--text' : 'display-4']"
            >
              Billit 
              <!-- <span class="font-weight-thin">Medical</span> -->
            </h1>
            <!-- :class="[$vuetify.breakpoint.smAndDown ? 'headline text--lighten-1' : 'display-1']" -->
            <div
              class="grey--text font-weight-light mb-md-12 mb-8"
              style="font-size: 33px;" :class="[$vuetify.breakpoint.smAndDown ? 'text--darken-2' : '']"
            >
              Don't bite the bullet on insurance billing. 
            </div>
            <v-hover v-slot:default="{ hover }" open-delay="100">
              <div>
                <v-slide-y-transition appear>
                  <p v-show="hover" style="font-size: 18.7px !important;" class="overline grey--text">use<em> Billit</em> to build better billing practices.</p>
                </v-slide-y-transition>
                <base-btn
                  height="64"
                  block href="/signup"
                  class="title"
                >
                  Sign Up Now
                </base-btn>
              </div>
            </v-hover>
          </v-col>
        </v-slide-x-reverse-transition>
      </v-row>
    </v-responsive>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeHero',

    data: () => ({
      
    }),
    // methods: {
      
    // }
  }
</script>

<style>
.card-float {
  -webkit-animation: action 2s infinite  alternate;
  animation: action 2s ease-in-out infinite  alternate;
}

@-webkit-keyframes action {
  0% { transform: translateY(0) }
  100% { transform: translateY(-10px) }
}
@keyframes action {
  0% { transform: translateY(0) }
  100% { transform: translateY(-10px) rotate(0deg); }
}
</style>
